import { Point2D } from '@trimble/utilities';
import type { ProjectGeoReference } from './project-geo-reference';

/**
 * Scene CRS for the 2D basemap:
 * 1. Active point-cloud CSIB + center
 * 2. Otherwise project geo
 */
export function pickEffectiveGeoReference(
  activePcCsib: string | undefined,
  activePcCenter: Point2D | undefined,
  projectGeo: ProjectGeoReference | undefined
): ProjectGeoReference | undefined {
  if (activePcCsib !== undefined && activePcCenter !== undefined) {
    return { csib: activePcCsib, center: activePcCenter };
  }

  return projectGeo;
}

/**
 * First visible cloud (insertion order) with both a CSIB and a center.
 * Paired by id so a center-only cloud cannot take another cloud's CRS.
 * Shared by the 2D basemap and the active CRS so both pick the same cloud.
 */
export function pickFirstLoadedPcGeo(
  loadedCsibs: ReadonlyMap<string, string>,
  loadedCenters: ReadonlyMap<string, Point2D>,
  visiblePointCloudIds: ReadonlySet<string>
): { pointCloudId: string; csib: string; center: Point2D } | undefined {
  for (const [pointCloudId, csib] of loadedCsibs) {
    if (!visiblePointCloudIds.has(pointCloudId)) {
      continue;
    }
    const center = loadedCenters.get(pointCloudId);
    if (center !== undefined) {
      return { pointCloudId, csib, center };
    }
  }
  return undefined;
}
